import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './XcorpJoinUs.css';
import axios from 'axios';
import OtpInputModal from '../Company/OtpInputModal'; // Reuse your OTP modal
import UserService from '../../Services/UserService'; // For SCC call
import ProjectsService from '../../Services/ProjectsService';
import { USER_CURRENT_API } from '../../Config/AppConfiguration';
import Cookies from 'universal-cookie';
import login from '../../Components/_Authentication/Login';
import PhoneInput, {
  isValidPhoneNumber
} from 'react-phone-number-input';

import 'react-phone-number-input/style.css';


const XcorpJoinUs = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [isCreateButtonActive, setIsCreateButtonActive] = useState(false);
  const [OtpModalOpen, setOtpModalOpen] = useState(false);
  const [OtpDataFromModal, setOtpDataFromModal] = useState([]);

  const navigate = useNavigate();

  const navigateHome = () => {
    navigate('/');
  };
   const cookies = new Cookies();
   
    const cookieNameUser = "userId";
    const cookieNameCurrentUser = "currentAPIMUser";
    const expiresIn = sessionStorage.getItem('expiresIn') ;

  const handlePhoneChange = (value) => {
    setPhoneNumber(value || '');
  };

  // Handle OTP input from modal
  const handleOtp = (OtpDataToProject) => {
    setOtpDataFromModal(OtpDataToProject);
  };

  // Call SCC and open OTP modal
  const triggerSCCAndOpenOtp = async () => {
    try {
      const response = await ProjectsService.getStrongConfirmationCodeForXcorpJoinUs();
      if (response.data && response.data.channel === "SMS") {
      
        setOtpModalOpen(true);
      } else {
        toast.error("OTP channel is not SMS or SCC failed.");
      }
    } catch (error) {
      toast.error("Failed to trigger OTP: " + (error.response?.data?.message || "Unknown error"));
    }
  };

  // OTP verification handler
  const verifyOtp = async (otpArray) => {
    if (!otpArray || otpArray.length === 0) return;
    const otp = otpArray.join('');
    try {
      const response = await axios.post(
        USER_CURRENT_API + '/activate',
        {},
        {
          withCredentials: true,
          headers: {
            'X-StrongConfirmationCode': otp
          }
        }
      );
      console.log("Activate response:", response);

      if (response.status === 200) {
        toast.success("Mobile number verified and registration completed!");
        setOtpModalOpen(false);

        // Check user status after activation
        const userDetailsResponse = await UserService.getuserDetails();
        console.log("User details after activation:", userDetailsResponse);

        if (userDetailsResponse.data.accountStatus === "Activated") {
          var _user_object = login.setCurrentUserObject(userDetailsResponse.data, expiresIn);
            _user_object.accountStatus = "Activated";
          _user_object = encodeURI(JSON.stringify(_user_object));
        
          cookies.set(cookieNameCurrentUser, _user_object, { path: '/' });
          cookies.set(cookieNameUser, response.data.email, { path: '/' });

           window.location.href = '/projects';
                
        } else {
          toast.error("Account not activated. Please try logging in again.");
          setTimeout(() => {
            window.location.href = '/';
          }, 2000);
        }
      } else {
        toast.error("OTP verification failed.");
      }
    } catch (error) {
      console.error("Activate error:", error);
      toast.error("OTP verification failed: " + (error.response?.data?.message || "Unknown error"));
    }
  };

  // Main submit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValidPhoneNumber(phoneNumber)) {
     toast.error('Please enter a valid phone number');
      return;
    }
    setIsCreateButtonActive(true);

    try {
      const response = await axios.post(
        USER_CURRENT_API + '/xcorpUserRegistration',
        { mobile: phoneNumber },
        { withCredentials: true }
      );
      toast.success("Internal User Registration completed successfully");

      // Always trigger SCC/OTP after registration success
      await triggerSCCAndOpenOtp();
    } catch (error) {
      toast.error("An error occurred during registration");
    } finally {
      setIsCreateButtonActive(false);
    }
  };
  const isFormValid = phoneNumber && isValidPhoneNumber(phoneNumber);
  
  return (
    <div className="xcorp-joinus-page-bg">
      <div className="xcorp-joinus-header">
        <h1>COMPLETE YOUR ACCOUNT</h1>
      </div>
      <div className="xcorp-joinus-main-content">
        <section className="xcorp-join-us-wrap">
          <div className="xcorp-info-text">
            Welcome to API Marketplace! Please complete your registration with your phone number to get the SMS OTP to authorize your access
          </div>
          <form onSubmit={handleSubmit}>
            <div className="xcorp-contact-num-wrap pe-2">
              <div className="xcorp-country-code-w">
                <div className="xcorp-phone-input-wrapper">
                  <PhoneInput
                    international
                    value={phoneNumber}
                    onChange={handlePhoneChange}
                    placeholder="Enter phone number"
                  />
                </div>
              </div>
            </div>
            <div className="xcorp-apim-pop-button-w xcorp-comm-button-wrap">
              <button
                type="submit"
                className="ui button xcorp-comm-button-style xcorp-primary xcorp-apim-pop-button-create"
                id="xcorpCreateJU"
                disabled={!isFormValid || isCreateButtonActive}
              >
                {!isCreateButtonActive ? <>CREATE</> :
                  <div style={{ display: 'block' }}>
                    <Spinner animation="border" variant="primary" style={{ width: 15, height: 15, marginRight: 5 }} />
                    JOINING...
                  </div>
                }
              </button>
              <button
                type="button"
                className="ui button xcorp-comm-button-style xcorp-secondary xcorp-apim-pop-button-cancel"
                id="xcorpCancelJU"
                onClick={navigateHome}
              >
                CANCEL
              </button>
            </div>
          </form>
          {OtpModalOpen && (
            <OtpInputModal
              ModalHeading={""}
              setOpenOtpModal={setOtpModalOpen}
              handleOtp={handleOtp}
              value={OtpDataFromModal}
              verifyOtp={verifyOtp}
              otpInputModelOpenendForAction={"xcorpUserRegistration"}
              resendOtp={triggerSCCAndOpenOtp}
              newMobile={phoneNumber}
            />
          )}
        </section>
      </div>
      {/* ✅ Using global ToastContainer from App.js - removed local instance */}
    </div>
  );
};

export default XcorpJoinUs;